export abstract class Event {
  eventName: string;
  properties: { [key: string]: any };
}

export class MicrocertificatePubliclyDownloaded extends Event {
  eventName = 'Microcertificate Publicly Downloaded';

  constructor(microcertificateHash: string, fileFormat: string) {
    super();

    this.properties = {
      microcertificateHash,
      fileFormat,
    };
  }
}

export class MicrocertificateCoursePageClicked extends Event {
  eventName = 'Microcertificate Course Page Clicked';

  constructor(microcertificateHash: string, coursePageName: string) {
    super();

    this.properties = {
      microcertificateHash,
      coursePageName,
    };
  }
}

export interface EventTracker {
  trackEvent(event: Event): void;
  trackPageView(): void;
}
